export default __webpack_public_path__ + "static/yeti-c9cb56207a6e925d61670aec21fad65f.png";